const landingModules = document.querySelectorAll('.landing-module');

if (landingModules.length) {
  const landingController = new ScrollMagic.Controller();

  landingModules.forEach((el) => {
    const stickyElem = el.querySelector('.landing-module__background');
    if (!stickyElem) return;

    new ScrollMagic.Scene({
      triggerElement: el,
      duration: el.offsetHeight,
      triggerHook: 0,
    })
      .setPin(stickyElem)
      .addTo(landingController);

    // if (isLocal()) {
    //   scene.addIndicators({ name: 'Sticky' });
    // }
  });
}

attachEvent('.landing-module__scroll', 'click', (el) => {
  const parent = el.target.closest('.sc-landing-module');
  const nextSection = parent.nextElementSibling;
  if (!nextSection) return;
  smoothScroll.scrollTo(nextSection);
});
